import { Component } from '@theme/component';

export class MediaThumbs extends Component {
  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;
    this.addEventListener('click', this.#onClick, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #controller = new AbortController();

  #onClick = (e) => {
    const btn = e.target.closest('[data-thumb-index]');
    if (!btn || !this.contains(btn)) return;

    const index = Number(btn.dataset.thumbIndex);
    if (!Number.isFinite(index)) return;

    const root = this.closest('.shopify-section, dialog') || document;
    const mediaGallery = root.querySelector('media-gallery');
    mediaGallery?.slideshow?.select(index, undefined, { animate: false });
  };
}

if (!customElements.get('media-thumbs')) {
  customElements.define('media-thumbs', MediaThumbs);
}
